export const announcementData = {
  text: "Special announcement: The 2023 Brightr Stories Competition, Begins February 7th. ",

  clickthroughUrl: {
    title: "Reserve your spot",
    url: "https://brightr.io/reserve-your-spot/",
    newWindow: true,
  },
  closed: false,
}

export const circlePropArray = [
  {
    radius: 8.928,
    x: 60,
    y: 23,
    hasContent: true,
    isInteractive: true,
    fillColor: "#BFD4D6",
  },
  {
    radius: 2.678,
    x: 45,
    y: 38,
    isInteractive: true,
    fillColor: "#BFD4D6",
  },
  {
    radius: 2.678,
    x: 72,
    y: 38,
    isInteractive: true,
    fillColor: "#BFD4D6",
  },
  {
    radius: 5.9534,
    x: 50,
    y: 58,
    hasContent: true,
    isInteractive: true,
    fillColor: "#BFD4D6",
  },
  {
    radius: 3.5,
    x: 63,
    y: 60,
    hasContent: true,
    isInteractive: true,
    fillColor: "#BFD4D6",
  },
  {
    radius: 5.9534,
    x: 77,
    y: 60,
    hasContent: true,
    isInteractive: true,
    fillColor: "#BFD4D6",
  },
  {
    radius: 10.76,
    x: 42,
    y: 95,
    hasContent: true,
    isInteractive: true,
    fillColor: "#BFD4D6",
  },
  {
    radius: 3,
    x: 58,
    y: 85,
    isInteractive: true,
    fillColor: "#BFD4D6",
  },

  {
    radius: 7,
    x: 70,
    y: 90,
    hasContent: true,
    isInteractive: true,
    fillColor: "#BFD4D6",
  },

  {
    radius: 15,
    x: 98,
    y: 90,
    isInteractive: true,
    fillColor: "#BFD4D6",
  },
]

export const circlePropArrayMobile = [
  {
    radius: 7,
    x: 70,
    y: 20,
    hasContent: true,
    isInteractive: true,
    fillColor: "#BFD4D6",
  },
  // {
  //   radius: 2.678,
  //   x: 47,
  //   y: 33,
  //   isInteractive: true,
  //   fillColor: "#BFD4D6",
  // },
  // {
  //   radius: 2.678,
  //   x: 85,
  //   y: 34,
  //   isInteractive: true,
  //   fillColor: "#BFD4D6",
  // },
  {
    radius: 7,
    x: 30,
    y: 65,
    hasContent: true,
    isInteractive: true,
    fillColor: "#BFD4D6",
  },
  {
    radius: 4,
    x: 72,
    y: 38,
    hasContent: true,
    isInteractive: true,
    fillColor: "#BFD4D6",
  },
  {
    radius: 5,
    x: 77,
    y: 55,
    hasContent: true,
    isInteractive: true,
    fillColor: "#BFD4D6",
  },
  {
    radius: 8,
    x: 20,
    y: 85,
    hasContent: true,
    isInteractive: true,
    fillColor: "#BFD4D6",
  },
  // {
  //   radius: 2,
  //   x: 53,
  //   y: 50,
  //   isInteractive: true,
  //   fillColor: "#BFD4D6",
  // },
  {
    radius: 5,
    x: 50,
    y: 50,
    hasContent: true,
    isInteractive: true,
    fillColor: "#BFD4D6",
  },

  {
    radius: 11,
    x: 80,
    y: 80,
    hasContent: true,
    isInteractive: true,
    fillColor: "#BFD4D6",
  },
]

export const indexHeaderData = {
  companyLogo: {
    logoSrc: "/logos/newBrightr.png",
    link: "https://brightr.io/",
  },
  navsData: [
    // { title: "Product", link: "https://brightr.io/product", local: false },
    // { title: "Story Hub", link: "/", local: true },
    // {
    //   title: "Brighter Magazine",
    //   link: "https://brightr.io/brightr-magazine",
    //   local: false,
    // },
    { title: "About", link: "https://brightr.io", local: false },
    // { title: "Contact Us", link: "https://brightr.io/contact", local: false },
  ],
  iconsData: [
    // {
    //   title: "email",
    //   src: "/icons/email.png",
    //   link: "mailto:info@brightr.io",
    // },
  ],
  buttonData: [
    // { title: "Get a Demo", link: "https://brightr.io/get-a-demo" },
    // { title: "Contact", link: "https://brightr.io/about" },
  ],
}

export const companies = [
  "Valence",
  "Agency73",
  "Avenga",
  "Wise Wolves",
  "Cloud Masonry",
  "Bigger Boat",
  "Endiem",
  "louie inc",
  "Solving IT",
  "Acquis",
  "Madison Ave",
  "Platinum Cubed",
  "Flok",
  "Coastal Cloud",
  "Simplus",
  "Silverline",
  "SaltClick",
  "Orion",
  "Addax",
  "Hebron Soft",
  "Carabiner Group",
]

export const homeSeoData = {
  title:
    "Brightr Story Library: Salesforce Success Stories & Implementation Case Studies",
  description:
    "Discover verified Salesforce implementation case studies across Sales Cloud, Service Cloud, Marketing Cloud, and industries. Filter by cloud, industry, or use case.",
}

export const indexFooterData = {
  companyLogo: {
    logoSrc: "/logos/brightrWhiteLogo.png",
    link: "https://brightr.io/",
  },
  navsData: [
    {
      title: "Privacy Policy",
      link: "https://brightr.io/privacy-policy",
    },
    { title: "Terms of Use", link: "https://brightr.io/termsofuse" },
  ],
  copyWriter: "Brightr 2025",
}

export const categorySeoData = {
  "healthcare-life-sciences": {
    title: "Healthcare and Life Sciences Client Success Stories | Brightr.io",
    description:
      "Explore Salesforce implementation success stories in Healthcare and Life Sciences. Find Salesforce partners with experience and client stories in Healthcare and Life Sciences.",
    h1: "Healthcare and Life Sciences Client Success Stories",
    products: {
      "sales-cloud": {
        title:
          "Sales Cloud in Healthcare and Life Sciences Client Success Stories | Brightr.io",
        description:
          "Explore Salesforce implementation success stories in Healthcare and Life Sciences which leverage Sales Cloud. Find Salesforce partners with Sales Cloud experience and client stories in Healthcare and Life Sciences.",
        h1: "Sales Cloud in Healthcare and Life Sciences Client Success Stories",
      },
      "service-cloud": {
        title:
          "Service Cloud in Healthcare and Life Sciences Client Success Stories | Brightr.io",
        description:
          "Explore Salesforce implementation success stories in Healthcare and Life Sciences which leverage Service Cloud. Find Salesforce partners with Service Cloud experience and client stories in Healthcare and Life Sciences.",
        h1: "Service Cloud in Healthcare and Life Sciences Client Success Stories",
      },
      "experience-cloud": {
        title:
          "Experience Cloud in Healthcare and Life Sciences Client Success Stories | Brightr.io",
        description:
          "Explore Salesforce implementation success stories in Healthcare and Life Sciences which leverage Experience Cloud. Find Salesforce partners with Experience Cloud experience and client stories in Healthcare and Life Sciences.",
        h1: "Experience Cloud in Healthcare and Life Sciences Client Success Stories",
      },
      "health-cloud": {
        title:
          "Health Cloud in Healthcare and Life Sciences Client Success Stories | Brightr.io",
        description:
          "Explore Salesforce implementation success stories in Healthcare and Life Sciences which leverage Health Cloud. Find Salesforce partners with Health Cloud experience and client stories in Healthcare and Life Sciences.",
        h1: "Health Cloud in Healthcare and Life Sciences Client Success Stories",
      },
      "financial-services-cloud": {
        title:
          "Financial Services Cloud in Healthcare and Life Sciences Client Success Stories | Brightr.io",
        description:
          "Explore Salesforce implementation success stories in Healthcare and Life Sciences which leverage Financial Services Cloud. Find Salesforce partners with Financial Services Cloud experience and client stories in Healthcare and Life Sciences.",
        h1: "Financial Services Cloud in Healthcare and Life Sciences Client Success Stories",
      },
      "nonprofit-cloud": {
        title:
          "Nonprofit Cloud in Healthcare and Life Sciences Client Success Stories | Brightr.io",
        description:
          "Explore Salesforce implementation success stories in Healthcare and Life Sciences which leverage Nonprofit Cloud. Find Salesforce partners with Nonprofit Cloud experience and client stories in Healthcare and Life Sciences.",
        h1: "Nonprofit Cloud in Healthcare and Life Sciences Client Success Stories",
      },
      "field-service": {
        title:
          "Field Service in Healthcare and Life Sciences Client Success Stories | Brightr.io",
        description:
          "Explore Salesforce implementation success stories in Healthcare and Life Sciences which leverage Field Service. Find Salesforce partners with Field Service experience and client stories in Healthcare and Life Sciences.",
        h1: "Field Service in Healthcare and Life Sciences Client Success Stories",
      },
      "data-cloud": {
        title:
          "Data Cloud in Healthcare and Life Sciences Client Success Stories | Brightr.io",
        description:
          "Explore Salesforce implementation success stories in Healthcare and Life Sciences which leverage Data Cloud. Find Salesforce partners with Data Cloud experience and client stories in Healthcare and Life Sciences.",
        h1: "Data Cloud in Healthcare and Life Sciences Client Success Stories",
      },
      "analytics-cloud": {
        title:
          "Analytics Cloud in Healthcare and Life Sciences Client Success Stories | Brightr.io",
        description:
          "Explore Salesforce implementation success stories in Healthcare and Life Sciences which leverage Analytics Cloud. Find Salesforce partners with Analytics Cloud experience and client stories in Healthcare and Life Sciences.",
        h1: "Analytics Cloud in Healthcare and Life Sciences Client Success Stories",
      },
      cpq: {
        title:
          "CPQ in Healthcare and Life Sciences Client Success Stories | Brightr.io",
        description:
          "Explore Salesforce implementation success stories in Healthcare and Life Sciences which leverage CPQ. Find Salesforce partners with CPQ experience and client stories in Healthcare and Life Sciences.",
        h1: "CPQ in Healthcare and Life Sciences Client Success Stories",
      },
    },
  },
  manufacturing: {
    title: "Manufacturing and Logistics Client Success Stories | Brightr.io",
    description:
      "Explore Salesforce implementation success stories in Manufacturing and Logistics. Find Salesforce partners with experience and client stories in Manufacturing and Logistics.",
    h1: "Manufacturing and Logistics Client Success Stories",
    products: {
      "sales-cloud": {
        title:
          "Sales Cloud in Manufacturing and Logistics Client Success Stories | Brightr.io",
        description:
          "Explore Salesforce implementation success stories in Manufacturing and Logistics which leverage Sales Cloud. Find Salesforce partners with Sales Cloud experience and client stories in Manufacturing and Logistics.",
        h1: "Sales Cloud in Manufacturing and Logistics Client Success Stories ",
      },
      "service-cloud": {
        title:
          "Service Cloud in Manufacturing and Logistics Client Success Stories | Brightr.io",
        description:
          "Explore Salesforce implementation success stories in Manufacturing and Logistics which leverage Service Cloud. Find Salesforce partners with Service Cloud experience and client stories in Manufacturing and Logistics.",
        h1: "Service Cloud in Manufacturing and Logistics Client Success Stories",
      },
      "experience-cloud": {
        title:
          "Experience Cloud in Manufacturing and Logistics Client Success Stories | Brightr.io",
        description:
          "Explore Salesforce implementation success stories in Manufacturing and Logistics which leverage Experience Cloud. Find Salesforce partners with Experience Cloud experience and client stories in Manufacturing and Logistics.",
        h1: "Experience Cloud in Manufacturing and Logistics Client Success Stories",
      },
      "health-cloud": {
        title:
          "Health Cloud in Manufacturing and Logistics Client Success Stories | Brightr.io",
        description:
          "Explore Salesforce implementation success stories in Manufacturing and Logistics which leverage Health Cloud. Find Salesforce partners with Health Cloud experience and client stories in Manufacturing and Logistics.",
        h1: "Health Cloud in Manufacturing and Logistics Client Success Stories",
      },
      "financial-services-cloud": {
        title:
          "Financial Services Cloud in Manufacturing and Logistics Client Success Stories | Brightr.io",
        description:
          "Explore Salesforce implementation success stories in Manufacturing and Logistics which leverage Financial Services Cloud. Find Salesforce partners with Financial Services Cloud experience and client stories in Manufacturing and Logistics.",
        h1: "Financial Services Cloud in Manufacturing and Logistics Client Success Stories",
      },
      "nonprofit-cloud": {
        title:
          "Nonprofit Cloud in Manufacturing and Logistics Client Success Stories | Brightr.io",
        description:
          "Explore Salesforce implementation success stories in Manufacturing and Logistics which leverage Nonprofit Cloud. Find Salesforce partners with Nonprofit Cloud experience and client stories in Manufacturing and Logistics.",
        h1: "Nonprofit Cloud in Manufacturing and Logistics Client Success Stories",
      },
      "field-service": {
        title:
          "Field Service in Manufacturing and Logistics Client Success Stories | Brightr.io",
        description:
          "Explore Salesforce implementation success stories in Manufacturing and Logistics which leverage Field Service. Find Salesforce partners with Field Service experience and client stories in Manufacturing and Logistics.",
        h1: "Field Service in Manufacturing and Logistics Client Success Stories",
      },
      "data-cloud": {
        title:
          "Data Cloud in Manufacturing and Logistics Client Success Stories | Brightr.io",
        description:
          "Explore Salesforce implementation success stories in Manufacturing and Logistics which leverage Data Cloud. Find Salesforce partners with Data Cloud experience and client stories in Manufacturing and Logistics.",
        h1: "Data Cloud in Manufacturing and Logistics Client Success Stories",
      },
      "analytics-cloud": {
        title:
          "Analytics Cloud in Manufacturing and Logistics Client Success Stories | Brightr.io",
        description:
          "Explore Salesforce implementation success stories in Manufacturing and Logistics which leverage Analytics Cloud. Find Salesforce partners with Analytics Cloud experience and client stories in Manufacturing and Logistics.",
        h1: "Analytics Cloud in Manufacturing and Logistics Client Success Stories",
      },
      cpq: {
        title:
          "CPQ in Manufacturing and Logistics Client Success Stories | Brightr.io",
        description:
          "Explore Salesforce implementation success stories in Manufacturing and Logistics which leverage CPQ. Find Salesforce partners with CPQ experience and client stories in Manufacturing and Logistics.",
        h1: "CPQ in Manufacturing and Logistics Client Success Stories",
      },
    },
  },
  "financial-services": {
    title: "Financial Services Client Success Stories | Brightr.io",
    description:
      "Explore Salesforce implementation success stories in Financial Services. Find Salesforce partners with experience and client stories in Financial Services.",
    h1: "Financial Services Client Success Stories",
    products: {
      "sales-cloud": {
        title:
          "Sales Cloud in Financial Services Client Success Stories | Brightr.io",
        description:
          "Explore Salesforce implementation success stories in Financial Services which leverage Sales Cloud. Find Salesforce partners with Sales Cloud experience and client stories in Financial Services.",
        h1: "Sales Cloud in Financial Services Client Success Stories",
      },
      "service-cloud": {
        title:
          "Service Cloud in Financial Services Client Success Stories | Brightr.io",
        description:
          "Explore Salesforce implementation success stories in Financial Services which leverage Service Cloud. Find Salesforce partners with Service Cloud experience and client stories in Financial Services.",
        h1: "Service Cloud in Financial Services Client Success Stories",
      },
      "experience-cloud": {
        title:
          "Experience Cloud in Financial Services Client Success Stories | Brightr.io",
        description:
          "Explore Salesforce implementation success stories in Financial Services which leverage Experience Cloud. Find Salesforce partners with Experience Cloud experience and client stories in Financial Services.",
        h1: "Experience Cloud in Financial Services Client Success Stories",
      },
      "health-cloud": {
        title:
          "Health Cloud in Financial Services Client Success Stories | Brightr.io",
        description:
          "Explore Salesforce implementation success stories in Financial Services which leverage Health Cloud. Find Salesforce partners with Health Cloud experience and client stories in Financial Services.",
        h1: "Health Cloud in Financial Services Client Success Stories",
      },
      "financial-services-cloud": {
        title:
          "Financial Services Cloud in Financial Services Client Success Stories | Brightr.io",
        description:
          "Explore Salesforce implementation success stories in Financial Services which leverage Financial Services Cloud. Find Salesforce partners with Financial Services Cloud experience and client stories in Financial Services.",
        h1: "Financial Services Cloud in Financial Services Client Success Stories",
      },
      "nonprofit-cloud": {
        title:
          "Nonprofit Cloud in Financial Services Client Success Stories | Brightr.io",
        description:
          "Explore Salesforce implementation success stories in Financial Services which leverage Nonprofit Cloud. Find Salesforce partners with Nonprofit Cloud experience and client stories in Financial Services.",
        h1: "Nonprofit Cloud in Financial Services Client Success Stories",
      },
      "field-service": {
        title:
          "Field Service in Financial Services Client Success Stories | Brightr.io",
        description:
          "Explore Salesforce implementation success stories in Financial Services which leverage Field Service. Find Salesforce partners with Field Service experience and client stories in Financial Services.",
        h1: "Field Service in Financial Services Client Success Stories",
      },
      "data-cloud": {
        title:
          "Data Cloud in Financial Services Client Success Stories | Brightr.io",
        description:
          "Explore Salesforce implementation success stories in Financial Services which leverage Data Cloud. Find Salesforce partners with Data Cloud experience and client stories in Financial Services.",
        h1: "Data Cloud in Financial Services Client Success Stories",
      },
      "analytics-cloud": {
        title:
          "Analytics Cloud in Financial Services Client Success Stories | Brightr.io",
        description:
          "Explore Salesforce implementation success stories in Financial Services which leverage Analytics Cloud. Find Salesforce partners with Analytics Cloud experience and client stories in Financial Services.",
        h1: "Analytics Cloud in Financial Services Client Success Stories",
      },
      cpq: {
        title: "CPQ in Financial Services Client Success Stories | Brightr.io",
        description:
          "Explore Salesforce implementation success stories in Financial Services which leverage CPQ. Find Salesforce partners with CPQ experience and client stories in Financial Services.",
        h1: "CPQ in Financial Services Client Success Stories",
      },
    },
  },
  "high-tech": {
    title: "Technology Client Success Stories | Brightr.io",
    description:
      "Explore Salesforce implementation success stories in Technology. Find Salesforce partners with experience and client stories in Technology.",
    h1: "Technology Client Success Stories",
    products: {
      "sales-cloud": {
        title: "Sales Cloud in Technology Client Success Stories | Brightr.io",
        description:
          "Explore Salesforce implementation success stories in Technology which leverage Sales Cloud. Find Salesforce partners with Sales Cloud experience and client stories in Technology.",
        h1: "Sales Cloud in Technology Client Success Stories",
      },
      "service-cloud": {
        title:
          "Service Cloud in Technology Client Success Stories | Brightr.io",
        description:
          "Explore Salesforce implementation success stories in Technology which leverage Service Cloud. Find Salesforce partners with Service Cloud experience and client stories in Technology.",
        h1: "Service Cloud in Technology Client Success Stories",
      },
      "experience-cloud": {
        title:
          "Experience Cloud in Technology Client Success Stories | Brightr.io",
        description:
          "Explore Salesforce implementation success stories in Technology which leverage Experience Cloud. Find Salesforce partners with Experience Cloud experience and client stories in Technology.",
        h1: "Experience Cloud in Technology Client Success Stories",
      },
      "health-cloud": {
        title: "Health Cloud in Technology Client Success Stories | Brightr.io",
        description:
          "Explore Salesforce implementation success stories in Technology which leverage Health Cloud. Find Salesforce partners with Health Cloud experience and client stories in Technology.",
        h1: "Health Cloud in Technology Client Success Stories",
      },
      "financial-services-cloud": {
        title:
          "Financial Services Cloud in Technology Client Success Stories | Brightr.io",
        description:
          "Explore Salesforce implementation success stories in Technology which leverage Financial Services Cloud. Find Salesforce partners with Financial Services Cloud experience and client stories in Technology.",
        h1: "Financial Services Cloud in Technology Client Success Stories",
      },
      "nonprofit-cloud": {
        title:
          "Nonprofit Cloud in Technology Client Success Stories | Brightr.io",
        description:
          "Explore Salesforce implementation success stories in Technology which leverage Nonprofit Cloud. Find Salesforce partners with Nonprofit Cloud experience and client stories in Technology.",
        h1: "Nonprofit Cloud in Technology Client Success Stories",
      },
      "field-service": {
        title:
          "Field Service in Technology Client Success Stories | Brightr.io",
        description:
          "Explore Salesforce implementation success stories in Technology which leverage Field Service. Find Salesforce partners with Field Service experience and client stories in Technology.",
        h1: "Field Service in Technology Client Success Stories",
      },
      "data-cloud": {
        title: "Data Cloud in Technology Client Success Stories | Brightr.io",
        description:
          "Explore Salesforce implementation success stories in Technology which leverage Data Cloud. Find Salesforce partners with Data Cloud experience and client stories in Technology.",
        h1: "Data Cloud in Technology Client Success Stories",
      },
      "analytics-cloud": {
        title:
          "Analytics Cloud in Technology Client Success Stories | Brightr.io",
        description:
          "Explore Salesforce implementation success stories in Technology which leverage Analytics Cloud. Find Salesforce partners with Analytics Cloud experience and client stories in Technology.",
        h1: "Analytics Cloud in Technology Client Success Stories",
      },
      cpq: {
        title: "CPQ in Technology Client Success Stories | Brightr.io",
        description:
          "Explore Salesforce implementation success stories in Technology which leverage CPQ. Find Salesforce partners with CPQ experience and client stories in Technology.",
        h1: "CPQ in Technology Client Success Stories",
      },
    },
  },
  nonprofit: {
    title: "Not For Profit Client Success Stories | Brightr.io",
    description:
      "Explore Salesforce implementation success stories in Not For Profit. Find Salesforce partners with experience and client stories in Not For Profit.",
    h1: "Not For Profit Client Success Stories",
    products: {
      "sales-cloud": {
        title:
          "Sales Cloud in Not For Profit Client Success Stories | Brightr.io",
        description:
          "Explore Salesforce implementation success stories in Not For Profit which leverage Sales Cloud. Find Salesforce partners with Sales Cloud experience and client stories in Not For Profit.",
        h1: "Sales Cloud in Not For Profit Client Success Stories",
      },
      "service-cloud": {
        title:
          "Service Cloud in Not For Profit Client Success Stories | Brightr.io",
        description:
          "Explore Salesforce implementation success stories in Not For Profit which leverage Service Cloud. Find Salesforce partners with Service Cloud experience and client stories in Not For Profit.",
        h1: "Service Cloud in Not For Profit Client Success Stories",
      },
      "experience-cloud": {
        title:
          "Experience Cloud in Not For Profit Client Success Stories | Brightr.io",
        description:
          "Explore Salesforce implementation success stories in Not For Profit which leverage Experience Cloud. Find Salesforce partners with Experience Cloud experience and client stories in Not For Profit.",
        h1: "Experience Cloud in Not For Profit Client Success Stories",
      },
      "health-cloud": {
        title:
          "Health Cloud in Not For Profit Client Success Stories | Brightr.io",
        description:
          "Explore Salesforce implementation success stories in Not For Profit which leverage Health Cloud. Find Salesforce partners with Health Cloud experience and client stories in Not For Profit.",
        h1: "Health Cloud in Not For Profit Client Success Stories",
      },
      "financial-services-cloud": {
        title:
          "Financial Services Cloud in Not For Profit Client Success Stories | Brightr.io",
        description:
          "Explore Salesforce implementation success stories in Not For Profit which leverage Financial Services Cloud. Find Salesforce partners with Financial Services Cloud experience and client stories in Not For Profit.",
        h1: "Financial Services Cloud in Not For Profit Client Success Stories",
      },
      "nonprofit-cloud": {
        title:
          "Nonprofit Cloud in Not For Profit Client Success Stories | Brightr.io",
        description:
          "Explore Salesforce implementation success stories in Not For Profit which leverage Nonprofit Cloud. Find Salesforce partners with Nonprofit Cloud experience and client stories in Not For Profit.",
        h1: "Nonprofit Cloud in Not For Profit Client Success Stories",
      },
      "field-service": {
        title:
          "Field Service in Not For Profit Client Success Stories | Brightr.io",
        description:
          "Explore Salesforce implementation success stories in Not For Profit which leverage Field Service. Find Salesforce partners with Field Service experience and client stories in Not For Profit.",
        h1: "Field Service in Not For Profit Client Success Stories",
      },
      "data-cloud": {
        title:
          "Data Cloud in Not For Profit Client Success Stories | Brightr.io",
        description:
          "Explore Salesforce implementation success stories in Not For Profit which leverage Data Cloud. Find Salesforce partners with Data Cloud experience and client stories in Not For Profit.",
        h1: "Data Cloud in Not For Profit Client Success Stories",
      },
      "analytics-cloud": {
        title:
          "Analytics Cloud in Not For Profit Client Success Stories | Brightr.io",
        description:
          "Explore Salesforce implementation success stories in Not For Profit which leverage Analytics Cloud. Find Salesforce partners with Analytics Cloud experience and client stories in Not For Profit.",
        h1: "Analytics Cloud in Not For Profit Client Success Stories",
      },
      cpq: {
        title: "CPQ in Not For Profit Client Success Stories | Brightr.io",
        description:
          "Explore Salesforce implementation success stories in Not For Profit which leverage CPQ. Find Salesforce partners with CPQ experience and client stories in Not For Profit.",
        h1: "CPQ in Not For Profit Client Success Stories",
      },
    },
  },
  "sales-cloud": {
    title: "Sales Cloud Client Success Stories | Brightr.io",
    description:
      "Explore Salesforce implementation success stories which leverage Sales Cloud. Find Salesforce partners with Sales Cloud experience and client stories.",
    h1: "Sales Cloud Client Success Stories",
  },
  "service-cloud": {
    title: "Service Cloud Client Success Stories | Brightr.io",
    description:
      "Explore Salesforce implementation success stories which leverage Service Cloud. Find Salesforce partners with Service Cloud experience and client stories.",
    h1: "Service Cloud Client Success Stories",
  },
  "experience-cloud": {
    title: "Experience Cloud Client Success Stories | Brightr.io",
    description:
      "Explore Salesforce implementation success stories which leverage Experience Cloud. Find Salesforce partners with Experience Cloud experience and client stories.",
    h1: "Experience Cloud Client Success Stories",
  },
  "health-cloud": {
    title: "Health Cloud Client Success Stories | Brightr.io",
    description:
      "Explore Salesforce implementation success stories which leverage Health Cloud. Find Salesforce partners with Health Cloud experience and client stories.",
    h1: "Health Cloud Client Success Stories",
  },
  "financial-services-cloud": {
    title: "Financial Services Cloud Client Success Stories | Brightr.io",
    description:
      "Explore Salesforce implementation success stories which leverage Financial Services Cloud. Find Salesforce partners with Financial Services Cloud experience and client stories.",
    h1: "Financial Services Cloud Client Success Stories",
  },
  "nonprofit-cloud": {
    title: "Nonprofit Cloud Client Success Stories | Brightr.io",
    description:
      "Explore Salesforce implementation success stories which leverage Nonprofit Cloud. Find Salesforce partners with Nonprofit Cloud experience and client stories.",
    h1: "Nonprofit Cloud Client Success Stories",
  },
  "field-service": {
    title: "Field Service Client Success Stories | Brightr.io",
    description:
      "Explore Salesforce implementation success stories which leverage Field Service. Find Salesforce partners with Field Service experience and client stories.",
    h1: "Field Service Client Success Stories",
  },
  "data-cloud": {
    title: "Data Cloud Client Success Stories | Brightr.io",
    description:
      "Explore Salesforce implementation success stories which leverage Data Cloud. Find Salesforce partners with Data Cloud experience and client stories.",
    h1: "Data Cloud Client Success Stories",
  },
  "analytics-cloud": {
    title: "Analytics Cloud Client Success Stories | Brightr.io",
    description:
      "Explore Salesforce implementation success stories which leverage Analytics Cloud. Find Salesforce partners with Analytics Cloud experience and client stories.",
    h1: "Analytics Cloud Client Success Stories",
  },
  cpq: {
    title: "CPQ Client Success Stories | Brightr.io",
    description:
      "Explore Salesforce implementation success stories which leverage CPQ. Find Salesforce partners with CPQ experience and client stories.",
    h1: "CPQ Client Success Stories",
  },
}

export const technologies = [
  "Education Cloud",
  "Experience Cloud",
  "Financial Services Cloud",
  "Heroku",
  "Government Cloud",
  "Einstein",
  "Field Service",
  "Health Cloud",
  "Manufacturing Cloud",
  "Marketing Cloud",
  "MuleSoft",
  "Quip",
  "Media Cloud",
  "Pardot",
  "Nonprofit Cloud",
  "Sales Cloud",
  "Service Cloud",
  "IoT Cloud",
  "Philanthropy Cloud",
  "Analytics Cloud",
  "Commerce Cloud",
  "Consumer Goods Cloud",
  "CPQ",
]
